import { creditCardBillingAddressEntryStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CreditCardBillingAddressEntry";
import { FormFieldStyle, FormInputWrapper } from "@insite/mobius/FormField";
import { InputStyle } from "@insite/mobius/TextField";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

creditCardBillingAddressEntryStyles.address1GridItem = {
    width: 12,
    css: css`
        >${FormFieldStyle}{
            >${FormInputWrapper}{
                > ${InputStyle} {
                    :focus {
                        border: 2px solid ${getColor("common.border")} !important;
                    }
                }
            }
        }
        `
}

creditCardBillingAddressEntryStyles.cityGridItem = {
    width: 12,
        css: css`
        >${FormFieldStyle}{
            >${FormInputWrapper}{
                > ${InputStyle} {
                    :focus {
                        border: 2px solid ${getColor("common.border")} !important;
                    }
                }
            }
        }
        `
}

creditCardBillingAddressEntryStyles.postalCodeGridItem = {
    width: 12,
        css: css`
        >${FormFieldStyle}{
            >${FormInputWrapper}{
                > ${InputStyle} {
                    :focus {
                        border: 2px solid ${getColor("common.border")} !important;
                    }
                }
            }
        }
        `
}